module.exports = __webpack_public_path__ + "img/icon-26.a8d7ac4f.svg";